import * as React from 'react';
import { Fade } from 'ui/transitions';
import { Loading, LoaderSize } from './Loading';

export type WaitProps = {
    loading: boolean;
};

export type Options = {
    size: LoaderSize;
    textKey?: string;
};

const fadeDuration = {
    enter: 200,
    exit: 400,
};

//
// waitUntilLoaded is a higher-order component that shows a loading spinner until
// the loading flag is clear. Once clear, it cross-fades to the wrapped control
//
export const waitUntilLoaded = ({ size = 'small', textKey }: Options) =>
    <T extends WaitProps & S, S>(Target: React.ComponentType<S>) =>
        class WaitUntilLoaded extends React.Component<T, {}> {
            static displayName = `waitUntilLoaded(${Target.displayName || Target.name || '?'})`;

            constructor(props: T) {
                super(props);
            }

            render() {
                // tslint:disable-next-line:no-any
                const { loading, ...otherProps } = this.props as any; // KILL: remove the "as any" when TypeScript supports this spread destructuring properly
                return (
                    <div>
                        <Fade visible={ !loading } duration={ 200 } unmountOnExit={ true }>
                            <Target { ...otherProps }/>
                        </Fade>
                        <Fade visible={ loading } duration={ fadeDuration } unmountOnExit={ true }>
                            <Loading size={ size } textKey={ textKey }/>
                        </Fade>
                    </div>
                );
            }
        }
;



// WEBPACK FOOTER //
// ./src/ui/shared/waitUntilLoaded.tsx